import styled from 'styled-components';

export const Opponent = styled.div<OpponentProps>`
    display: flex;
    flex-direction: column;
    gap: 4px;
    justify-content: center;
    left: 50%;
    position: ${({ $index }) => ($index ? 'absolute' : 'relative')};
    top: 0;
    transform: ${({ $offset, $visible }) => `scale(${$visible ? 1 : 0.9}) translateX(${$offset}%)`};
    transition: ${({ $animate }) => ($animate ? 'all' : 'none')} 0.5s ease-in-out;
    z-index: ${({ $index }) => 4 - $index};
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    pointer-events: ${({ $visible }) => ($visible ? 'all' : 'none')};
`;
